module.exports = __webpack_public_path__ + "img/DICH_VU.6af0660a.svg";